import PropTypes from 'prop-types';
import classnames from 'classnames';
import { BookingBar as BookingBarComponent } from '@spotahome/ui-library';
import { trans } from '@spotahome/soyuz/client';
import {
  usePricingContext,
  useDisplayListingPricing
} from '@spotahome/marketplace-common/src/context/PricingContext';
import RentableUnitPriceOffer from '@spotahome/marketplace-common/src/components/RentableUnitPriceOffer';

import OffersLabel from '@spotahome/ui-library/src/tenant/components/OffersLabel';

import BookingBarButtons from '../BookingBarButtons';

import './BookingBar.scss';

const getPriceAmount = (priceRange, minimumPrice) =>
  (priceRange.type === 'fixed'
    ? priceRange.fixedPrice
    : priceRange.seasonalPrice) || minimumPrice;

const BookingBar = ({
  moveIn = '',
  moveOut = '',
  className = '',
  button = {},
  price = {},
  showPrice = true,
  offers = [],
  isBookable
}) => {
  const { priceRange, minimumPrice, pricingDetails } = usePricingContext();
  const displayPricing = useDisplayListingPricing();

  const onClickButton = e => {
    const buttonClickProps = button.onClick;
    if (buttonClickProps && typeof buttonClickProps === 'function') {
      buttonClickProps(e);
    }
  };

  const showOfferLabel = pricingDetails?.hasOffer;
  const showDates = moveIn || moveOut;

  const renderPrice = () => {
    if (showOfferLabel) {
      return (
        <div className="booking-bar__price-with-offer">
          <OffersLabel
            appliedOfferValue={displayPricing.discount}
            offers={offers}
          />
          <RentableUnitPriceOffer {...displayPricing} />
        </div>
      );
    }

    if (!showDates) {
      return <></>;
    }

    return {
      ...price,
      className: classnames('booking-bar__price'),
      exact: true,
      amount: getPriceAmount(priceRange, minimumPrice),
      monthly: true
    };
  };

  return (
    <BookingBarComponent
      offers={offers}
      chat={<></>}
      showPrice={showPrice}
      button={
        <BookingBarButtons
          {...button}
          onClick={onClickButton}
          isBookable={isBookable}
          moveIn={moveIn}
          moveOut={moveOut}
        />
      }
      price={renderPrice()}
      className={classnames('booking-bar', className)}
      underPriceLabel={
        price.monthly && (
          <span>{trans('property_show.book_now_card.per_month')}</span>
        )
      }
    />
  );
};

BookingBar.propTypes = {
  moveIn: PropTypes.string,
  moveOut: PropTypes.string,
  className: PropTypes.string,
  button: PropTypes.object,
  price: PropTypes.object,
  showPrice: PropTypes.bool,
  isBookable: PropTypes.bool.isRequired,
  offers: PropTypes.arrayOf(PropTypes.shape({}))
};

export default BookingBar;
